;
define("home.tpl", function(){});

